module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-03-0ecb09a263c635a619e714517fe97f37.jpg";